import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const WMS = lazy(() => import("../pages/wms/_page"));
const WMSEcommerce = lazy(() => import("../pages/wms/ecommerce/page"));
const WMS3PL = lazy(() => import("../pages/wms/3pl/page"));
const TMS = lazy(() => import("../pages/tms/page"));
const About = lazy(() => import("../pages/about/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/wms",
    element: <WMS />,
  },
  {
    path: "/wms/ecommerce",
    element: <WMSEcommerce />,
  },
  {
    path: "/wms/3pl",
    element: <WMS3PL />,
  },
  {
    path: "/tms",
    element: <TMS />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
